import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'hammerjs';
import {
  MdAutocompleteModule,
  MdButtonModule,
  MdButtonToggleModule,
  MdCardModule,
  MdCheckboxModule,
  MdChipsModule,
  MdCoreModule,
  MdDatepickerModule,
  MdDialogModule,
  MdExpansionModule,
  MdGridListModule,
  MdIconModule,
  MdInputModule,
  MdListModule,
  MdMenuModule,
  MdNativeDateModule,
  MdPaginatorModule,
  MdProgressBarModule,
  MdProgressSpinnerModule,
  MdRadioModule,
  MdRippleModule,
  MdSelectModule,
  MdSidenavModule,
  MdSliderModule,
  MdSlideToggleModule,
  MdSnackBarModule,
  MdSortModule,
  MdTableModule,
  MdTabsModule,
  MdToolbarModule,
  MdTooltipModule, DateAdapter, MD_DATE_FORMATS
} from '@angular/material';
import { PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AgmCoreModule, MapsAPILoader } from '@agm/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HttpClientModule } from '@angular/common/http';

// import third-party modules
// import ng2-date-picker modules
import { DpDatePickerModule } from 'ng2-date-picker';
import { GaService } from './Common/ng2-date-picker/ga.service';


// import local modules
import { routing } from './app.routes';
import { AppGlobals } from './Common/Services/app.global';
import { SharedService } from './Common/Services/shared.service';
import { Utility } from './Common/Services/utility';
import { AppConfig } from './Common/appConfiguration';
import { CustomLazyAPIKeyLoader } from './Common/Services/custom-apikey-loader.service';
import { RequiredFieldDirective } from './Common/Directives/required-field.directive';
import { MenuNavigationDirective } from './Common/Directives/menu-navigation.directive';
import { ValidatePhoneDirective } from './Common/Directives/validate-phone.directive';
import { ValidateCertificateIdDirective } from './Common/Directives/validate-certificate-id.directive';
import { ValidateOnlyNumericDirective } from './Common/Directives/validate-only-numeric.directive';
import { MinMaxDirective } from './Common/Directives/min-max.directive';
import { ShowUnSavedChangesAlertDirective } from './Common/Directives/show-unsavedchanges-alert.diretive';
import { ShowDropdownDirective } from './Common/Directives/show-dropdown.directive';
import { AppComponent } from './Components/app.component';
import { PanelPageComponent } from './Components/panel-page/panel-page.component';
import { DashboardComponent } from './Components/dashboard/dashboard.component';
import { DialogExamDetailsComponent } from './Components/dialog-exam-details/dialog-exam-details.component';
import { ScheduleExamLocationComponent } from './Components/schedule-exam-location/schedule-exam-location.component';
import { PageNotFoundComponent } from './Components/page-not-found/page-not-found.component';
import { ScheduleExamDateComponent } from './Components/schedule-exam-date/schedule-exam-date.component';
import { DialogConfirmComponentComponent } from './Components/dialog-confirm-component/dialog-confirm-component.component';
import { AppMessage } from './Common/appMessage';
import { AppHTMLText } from './Common/appHtmlText';
import { AdmManageLocationComponent } from './Components/adm-manage-location/adm-manage-location.component';
import { AdmManageCountryComponent } from './Components/adm-manage-country/adm-manage-country.component';
import { AdmUpdateCountryComponent } from './Components/adm-manage-country/adm-update-country/adm-update-country.component';
import { AdmUpdateLocationComponent } from './Components/adm-manage-location/adm-update-location/adm-update-location.component';
import { AdmManageGlobalAdminComponent } from './Components/adm-manage-global-admin/adm-manage-global-admin.component';
import { AdmUpdateGlobalAdminComponent } from './Components/adm-manage-global-admin/adm-update-global-admin/adm-update-global-admin.component';
import { AdmManageKoalaconfigComponent } from './Components/adm-manage-location/adm-manage-koalaconfig/adm-manage-koalaconfig.component';
import { AdmManageLocationSettingComponent } from './Components/adm-manage-location-setting/adm-manage-location-setting.component';
import { CustomTimeControlComponent } from './Components/custom-time-control/custom-time-control.component';
import { AdmManageSiteAdminComponent } from './Components/adm-manage-site-admin/adm-manage-site-admin.component';
import { AdmUpdateSiteAdminComponent } from './Components/adm-manage-site-admin/adm-update-site-admin/adm-update-site-admin.component';
import { AdmBlacklistExamComponent } from './Components/adm-manage-location-setting/adm-blacklist-exam/adm-blacklist-exam.component';
import { AdmManageRegionalAdminComponent } from './Components/adm-manage-regional-admin/adm-manage-regional-admin.component';
import { AdmUpdateRegionalAdminComponent } from './Components/adm-manage-regional-admin/adm-update-regional-admin/adm-update-regional-admin.component';
import { AdmManageEligibilitiesComponent } from './Components/adm-manage-eligibilities/adm-manage-eligibilities.component';
import { AdmNominateUsersLocationUpdatesComponent } from './Components/adm-nominate-users-location-updates/adm-nominate-users-location-updates.component';
import { AdmManageExceptionCalenderComponent } from './Components/adm-manage-exception-calender/adm-manage-exception-calender.component';
import { AdmManagePendingApprovalsComponent } from './Components/adm-manage-pending-approvals/adm-manage-pending-approvals.component';
import { AdmViewPendingApprovalsComponent } from './Components/adm-manage-pending-approvals/adm-view-pending-approvals/adm-view-pending-approvals.component';
import { AdmManageErrorCaseComponent } from './Components/adm-manage-eligibilities/adm-manage-error-case/adm-manage-error-case.component';
import { DateTimeFormatPipe } from './Common/Pipe/date-time-format.pipe';
import { SlotsFormatPipe } from './Common/Pipe/slots-format.pipe';
import { AdmManageConflictCasesComponent } from './Components/adm-manage-conflict-cases/adm-manage-conflict-cases.component';
import { AdmManageProctorTeamLeadComponent } from './Components/adm-manage-proctor-team-lead/adm-manage-proctor-team-lead.component';
import { AdmUpdateProctorTeamLeadComponent } from './Components/adm-manage-proctor-team-lead/adm-update-proctor-team-lead/adm-update-proctor-team-lead.component';
import { AdmManageConcurrentExamsComponent } from './Components/adm-manage-concurrent-exams/adm-manage-concurrent-exams.component';
import { AdmManageUniversalOperationalHoursComponent } from './Components/adm-manage-universal-operational-hours/adm-manage-universal-operational-hours.component';
import { AdmRemoveOfficeComponent } from './Components/adm-manage-office/adm-remove-office/adm-remove-office.component';
import { AdmManageOfficeComponent } from './Components/adm-manage-office/adm-manage-office.component';
import { AdmManageProctorTeamLeadService } from './Components/adm-manage-proctor-team-lead/adm-manage-proctor-team-lead.service';
import { IesHttpClient } from "./Common/ies-http-client.service";
import { AppDateAdapter, APP_DATE_FORMATS } from "./Common/app-date-adapter";
import { AuthenticateUserComponent } from './Components/authenticate-user/authenticate-user.component';
import { ActivateRoutesGuard } from "./Common/activate-routes-guard";
import { ActivateRoutes_ID_Guard } from "./Common/activate-route_ID-guard";
import { AdmManageProctorAlertConfigComponent } from './Components/adm-manage-proctor-alert-config/adm-manage-proctor-alert-config.component';
import { AdmEligibilityMessagesComponent } from './Components/adm-eligibility-messages/adm-eligibility-messages.component';
import { AdmManageDomainComponent } from './Components/adm-manage-domain/adm-manage-domain.component';
import { LogoutComponent } from './Components/logout/logout.component';
import { AdmManageChatIdleTimeComponent } from './Components/adm-manage-chat-idle-time/adm-manage-chat-idle-time.component';
import { PublicLocationsComponent } from './Components/public-locations/public-locations.component';
import { DashboardGuard } from './Common/guards/dashboard.guard';
import { ScheduleExamGuard } from './Common/guards/schedule-exam.guard';
import { ManageLocationGuard } from './Common/guards/manage-location.guard';
import { ManageCountryGuard } from './Common/guards/manage-country.guard';
import { ManageGlobalAdminGuard } from './Common/guards/manage-global-admin.guard';
import { ManageLocationSettingsGuard } from './Common/guards/manage-location-settings.guard';
import { ManageSiteAdminGuard } from './Common/guards/manage-site-admin.guard';
import { ManageRegionalAdminGuard } from './Common/guards/manage-regional-admin.guard';
import { ManageEligibilitiesGuard } from './Common/guards/manage-eligibilities.guard';
import { NominateUsersLocationUpdatesGuard } from './Common/guards/nominate-users-location-updates.guard';
import { ExceptionCalendarGuard } from './Common/guards/exception-calendar.guard';
import { ManagePendingApprovalsGuard } from './Common/guards/manage-pending-approvals.guard';
import { ManageErrorCaseGuard } from './Common/guards/manage-error-case.guard';
import { ManageProctorTeamLeadGuard } from './Common/guards/manage-proctor-team-lead.guard';
import { ManageProctorsGuard } from './Common/guards/manage-proctors.guard';
import { ManageConcurrentExamsGuard } from './Common/guards/manage-concurrent-exams.guard';
import { ManageUniversalOperationalHoursGuard } from './Common/guards/manage-universal-operational-hours.guard';
import { ManageOfficeGuard } from './Common/guards/manage-office.guard';
import { ManageProctorAlertConfigGuard } from './Common/guards/manage-proctor-alert-config.guard';
import { EligibilityMessagesGuard } from './Common/guards/eligibility-messages.guard';
import { ManageChatIdleTimeGuard } from './Common/guards/manage-chat-idle-time.guard';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  minScrollbarLength: 50,
  maxScrollbarLength: 300
};

@NgModule({
  declarations: [
    DateTimeFormatPipe,
    SlotsFormatPipe,
    RequiredFieldDirective,
    ValidatePhoneDirective,
    ValidateCertificateIdDirective,
    ValidateOnlyNumericDirective,
    MenuNavigationDirective,
    ShowUnSavedChangesAlertDirective,
    ShowDropdownDirective,
    MinMaxDirective,
    AppComponent,
    PanelPageComponent,
    DashboardComponent,
    DialogExamDetailsComponent,
    ScheduleExamLocationComponent,
    PageNotFoundComponent,
    ScheduleExamDateComponent,
    DialogConfirmComponentComponent,
    AdmManageLocationComponent,
    AdmManageCountryComponent,
    AdmUpdateCountryComponent,
    AdmManageGlobalAdminComponent,
    AdmUpdateGlobalAdminComponent,
    AdmUpdateLocationComponent,
    AdmManageKoalaconfigComponent,
    AdmManageLocationSettingComponent,
    CustomTimeControlComponent,
    AdmManageSiteAdminComponent,
    AdmUpdateSiteAdminComponent,
    AdmBlacklistExamComponent,
    AdmManageRegionalAdminComponent,
    AdmUpdateRegionalAdminComponent,
    AdmManageEligibilitiesComponent,
    AdmNominateUsersLocationUpdatesComponent,
    AdmManageExceptionCalenderComponent,
    AdmManagePendingApprovalsComponent,
    AdmViewPendingApprovalsComponent,
    AdmManageErrorCaseComponent,
    AdmManageConflictCasesComponent,
    AdmManageProctorTeamLeadComponent,
    AdmUpdateProctorTeamLeadComponent,
    AdmManageConcurrentExamsComponent,
    AdmManageUniversalOperationalHoursComponent,
    AdmManageOfficeComponent,
    AdmRemoveOfficeComponent,
    AuthenticateUserComponent,
    AdmManageProctorAlertConfigComponent,
    AdmEligibilityMessagesComponent,
    AdmManageDomainComponent,
    LogoutComponent,
    AdmManageChatIdleTimeComponent,
    PublicLocationsComponent,
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    MdAutocompleteModule,
    MdButtonModule,
    MdButtonToggleModule,
    MdCardModule,
    MdCheckboxModule,
    MdChipsModule,
    MdCoreModule,
    MdDatepickerModule,
    MdDialogModule,
    MdExpansionModule,
    MdGridListModule,
    MdIconModule,
    MdInputModule,
    MdListModule,
    MdMenuModule,
    MdNativeDateModule,
    MdPaginatorModule,
    MdProgressBarModule,
    MdProgressSpinnerModule,
    MdRadioModule,
    MdRippleModule,
    MdSelectModule,
    MdSidenavModule,
    MdSliderModule,
    MdSlideToggleModule,
    MdSnackBarModule,
    MdSortModule,
    MdTableModule,
    MdTabsModule,
    MdToolbarModule,
    MdTooltipModule,
    PerfectScrollbarModule,
    routing,
    AgmCoreModule.forRoot(),
    DpDatePickerModule,
    ReactiveFormsModule,
  ],
  providers: [IesHttpClient, AppGlobals, SharedService, Utility, AppConfig, GaService, AppMessage, AppHTMLText, AdmManageProctorTeamLeadService, DashboardGuard, ScheduleExamGuard, ManageLocationGuard, ManageCountryGuard, ManageGlobalAdminGuard, ManageLocationSettingsGuard, ManageSiteAdminGuard, ManageRegionalAdminGuard, ManageEligibilitiesGuard, NominateUsersLocationUpdatesGuard, ExceptionCalendarGuard, ManagePendingApprovalsGuard, ManageErrorCaseGuard, ManageProctorTeamLeadGuard, ManageProctorsGuard, ManageConcurrentExamsGuard, ManageUniversalOperationalHoursGuard, ManageOfficeGuard, ManageProctorAlertConfigGuard, EligibilityMessagesGuard, ManageChatIdleTimeGuard, ActivateRoutesGuard, ActivateRoutes_ID_Guard, Title,
    {
      provide: DateAdapter, useClass: AppDateAdapter
    },
    {
      provide: MD_DATE_FORMATS, useValue: APP_DATE_FORMATS
    },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    { provide: MapsAPILoader, useClass: CustomLazyAPIKeyLoader }
  ],
  entryComponents: [DialogExamDetailsComponent, DialogConfirmComponentComponent, AdmManageDomainComponent, AdmManageKoalaconfigComponent, AdmBlacklistExamComponent, AdmRemoveOfficeComponent],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor() {
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/app.module.ts